module.exports = require("@pandora/data-model-member");